<template>
    <span>
        <b-button class="align-baseline mr-1" title="Edit" variant="default" @click="handleEditClick">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="metadata.permissions.owner_login"
            class="align-baseline mr-1"
            title="Login"
            variant="default"
            v-b-modal="loginModalID"
        >
            <font-awesome-icon :icon="['fas', 'circle-user']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline mr-1"
            title="Send Login Info"
            variant="default"
            v-b-modal="sendLoginInfoModalID"
        >
            <font-awesome-icon :icon="['fas', 'paper-plane']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline" title="Delete" variant="default" v-b-modal="deleteModalID">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="sendLoginInfoModalID" title="Send Login Info" @shown="onModalShown" @ok="sendLoginInfo"
            >Are you sure you want to reset owner #{{ ownerID }} credentials?</modal
        >
        <modal :id="loginModalID" title="Login" @shown="onModalShown" @ok="loginOwner"
            >Are you sure you want to log out as Subscriber and log in as owner #{{ ownerID }}?</modal
        >
        <modal :id="deleteModalID" title="Delete Owner" @shown="onModalShown" @ok="deleteOwner"
            >Are you sure you want to delete owner #{{ ownerID }}?</modal
        >
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                ownerID: 0,
                sendLoginInfoModalID: '',
                loginModalID: '',
                deleteModalID: '',
            };
        },
        computed: {
            ...mapGetters('owner', ['metadata']),
        },
        created() {
            this.ownerID = this.params.data.id;
            this.sendLoginInfoModalID = `modal-send-login-info-${this.ownerID}`;
            this.loginModalID = `modal-login-owner-${this.ownerID}`;
            this.deleteModalID = `modal-delete-owner-${this.ownerID}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleEditClick() {
                this.$router.push(`/app/owner/${this.ownerID}/edit/`);
            },
            async sendLoginInfo() {
                try {
                    await API.post(`/app/owner/owner/${this.ownerID}/send-login-info/`);
                    this.successToast({ text: `Login information has been sent successfully.` });
                } catch (error) {
                    this.errorToast({ text: `Could not send login information.` });
                    return;
                }
            },
            loginOwner() {
                window.location = `/system/owners/login_as_owner/${this.ownerID}`;
            },
            async deleteOwner() {
                try {
                    await API.delete(`/app/owner/owner/${this.ownerID}/`);
                } catch (error) {
                    this.errorToast({ text: `Could not delete owner.` });
                    return;
                }
                this.params.api.refreshServerSide();
            },
        },
    };
</script>
